<script setup>
import { watch, computed } from 'vue'
import { toast } from 'vue3-toastify';
import { usePage } from '@inertiajs/vue3'
import Default from './Layout/Default.vue'
import Pay from './Layout/Pay.vue'
import Testing from './Components/Testing.vue'

const page = usePage()

const flash = computed(() => page?.props?.flash)
const layout = computed(() => page?.props?.layout);
const testing = computed(() => page?.props?.testing);

watch(flash, (newVal) => {
    if (newVal && newVal?.message?.length >= 1) {
        let type = 'success'
        if (newVal.element === 'flash-error') {
            type = 'error'
        }
        toast(newVal.message, { type: type, position: toast.POSITION.BOTTOM_RIGHT, autoClose: 1000 })
    }
})
</script>

<template>
    <div>
        <Testing v-if="testing" />
        <Default v-if="layout === 'Default'">
            <slot></slot>
        </Default>
        <Pay v-else-if="layout === 'Pay'">
            <slot></slot>
        </Pay>
        <slot v-else />
    </div>
</template>

